<template lang="pug">
  div
    payout-top(:company="company" :searchText.sync="searchText" :isFetching="isFetching" :filters="filters" :companyTiers="companyTiers" @updateFilter="updateFilter")
    v-divider.basic300(v-if="!filterChanged")
    payout-list-filters-chip(v-if="filterChanged" :company="company" :filters="filters" :companyTiers="companyTiers" @updateFilter="updateFilter")
    payout-bulk-actions(:selectedItems="selectedItems" :allItems="commissions" :isFetching="isFetching" :isLoading="isLoading" @updateAll="updateAllTask" @process="processTask")
    v-divider.basic300.mb-3
    v-container.pa-0(style="max-width: 600px")
      .bulk-actions
      v-layout.my-6.px-2.pt-2(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-layout.my-6.px-2.pt-2(v-if="commissions.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              div.p2.basic600--text.text-center No commission found.
        div(v-else)
          payout-item(v-for="(commission, index) in commissions" ref="payoutItem" :key="commission.id" :item="commission" :companyTiers="companyTiers" :selected="selectedItems.some(selected => selected.id === commission.id)" @updateData="updateTask" @removeData="removeTask")
        div.py-3.px-4
          y-pagination-custom(v-if="commissions.length > 0" v-model="page" :parentPageSize.sync="pageSize" :count="count" :text="'Show payouts'")
</template>

<script>
import { mapActions } from 'vuex'
import PayoutTop from '@/components/resellers/payouts/PayoutTop.vue'
import PayoutListFiltersChip from '@/components/resellers/payouts/PayoutListFiltersChip.vue'
import PayoutBulkActions from '@/components/resellers/payouts/PayoutBulkActions.vue'
import PayoutItem from '@/components/resellers/payouts/PayoutItem.vue'

export default {
  name: 'PayoutToProcess',
  components: { PayoutTop, PayoutListFiltersChip, PayoutItem, PayoutBulkActions },
  props: {
    company: {
      type: Object,
      default: () => {
        return {}
      }
    },
    companyTiers: {
      type: Array,
      required: true
    },
    toProcessCount: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    isFetching: false,
    isLoading: false,
    fetchUrl: '/members/commissions/',
    searchCountDown: null,
    page: 1,
    pageSize: 20,
    count: 0,
    searchText: '',
    commissions: [],
    selectedItems: [],
    filters: {
      sort: 'newest',
      range: {
        name: 'All',
        value: null,
        dates: null
      },
      tier: null
    },
    filterChanged: false
  }),
  computed: {
    filterParams() {
      return {
        company: this.company.id,
        ordering: this.filters.sort === 'newest' ? '-created' : 'created',
        page: this.page,
        page_size: this.pageSize,
        search: this.searchText,
        tier: this.filters.tier ? this.filters.tier : null,
        range: this.filters.range.dates ? null : this.filters.range.value,
        created_before: this.filters.range.dates ? this.filters.range.dates[1] : null,
        created_after: this.filters.range.dates ? this.filters.range.dates[0] : null
      }
    }
  },
  async mounted() {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
    await this.fetchCommissions()
    this.$emit('update:toProcessCount', this.count)
  },
  watch: {
    page(val) {
      history.pushState({}, null, location.pathname + this.$route.hash + '?page=' + val)
      if (!this.isFetching) {
        this.fetchCommissions()
      }
    },
    pageSize() {
      this.page = 1
      this.fetchCommissions()
    },
    searchText: {
      handler() {
        if (this.searchCountDown) {
          clearTimeout(this.searchCountDown)
        }
        this.searchCountDown = setTimeout(() => {
          this.page = 1
          this.fetchCommissions()
        }, 200)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCommissions() {
      this.isFetching = true
      return this.axios
        .get(this.fetchUrl, { params: this.filterParams })
        .then(resp => {
          this.commissions = resp.data.results
          this.count = resp.data.count
          this.isFetching = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    removeTask(item) {
      const index = this.selectedItems.findIndex(selected => selected.id === item.id)
      if (index !== -1) {
        this.selectedItems.splice(index, 1)
      }
    },
    updateTask(item) {
      const index = this.selectedItems.findIndex(selected => selected.id === item.id)
      if (index === -1) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems[index] = item
      }
    },
    updateAllTask(val) {
      this.commissions.forEach(commission => {
        val ? this.updateTask(commission) : this.removeTask(commission)
      })
    },
    updateFilter(newVal) {
      this.filters = newVal
      this.filterChanged = true
      this.fetchCommissions()
    },
    async processTask() {
      this.isLoading = true
      const data = { commissions: this.selectedItems.map(item => item.id) }
      this.axios
        .post('/members/payouts', data)
        .then(async () => {
          this.$emit('update:toProcessCount', this.toProcessCount - data.commissions.length)
          this.showMessage(['success', this.$t('success_message.commissions_processed')])
          this.$emit('nextTab')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>